import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  step: 'login' | 'otp';
  email: string;
  setStep: (step: 'login' | 'otp') => void;
  setEmail: (email: string) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      step: 'login',
      email: '',
      setStep: (step) => set({ step }),
      setEmail: (email) => set({ email }),
      clearAuth: () => set({ step: 'login', email: '' }),
    }),
    {
      name: 'auth-storage',
    },
  ),
);
